import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';

const ProdIOOReqAddRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit"
                        action={{ InputType: "input", actionId: "refresh", paramName: "reqQty1", actionParam:{"updateQty":1} }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" 
                        action={{ InputType: "input", actionId: "refresh", paramName: "reqQty2", actionParam:{"updateQty":1} }} />
                </li>
            </ul>
        )
}

export default ProdIOOReqAddRow
